export default {
  web: {
    common: {
      for: "für",
      today: "Heute",
      unknown: "Unbekannt",
      checkout: "Zur Kasse",
      noOdds: "Keine Quoten",
    },
    navigation: {
      tools: "Tools",
      getLinematePlus: "Linemate+ holen",
      startFreeTrial: "Kostenlose Testphase starten",
      downloadLinemate: "Linemate herunterladen",
      profileSettings: "Profileinstellungen",
      closeMyPicks: "Meine Tipps schließen",
      offSeason: "{{league}} ist in der Offseason. Bis zur nächsten Saison.",
      search: {
        teams: "Teams",
        noResultsFor: "Keine Ergebnisse für \"{{searchTerm}}\" gefunden",
      },
      toolsMenu: {
        opponentDefensiveRank: "Defensivrang des Gegners",
        startingOpponentPitchers: "Starting Pitcher des Gegners",
      },
    },
    toastModal: {
      title: "Was ist neu?",
      items: {
        checkout: "Gehe mit Meine Tipps direkt zu deinem bevorzugten Anbieter.",
        preferredOdds: "Zeige Quoten für Trends mit deinen bevorzugten Quoten an (verfügbar für Linemate+ Nutzer).",
      },
      actions: {
        dismiss: "Schließen",
      },
    },
    carousel: {
      previous: "Zurück",
      next: "Weiter",
    },
  },
};
